<template>
	<div class="service-page-bottom">
		<div class="service-bottom-left" @click="toJinChengButler">
			<img class="service-icon" :src="serviceIcon" alt="" />
			<div class="service-info">
				<div class="service-title">精诚服务管家</div>
				<div class="service-tip">售后门店在线服务</div>
			</div>
		</div>
		<div class="service-bottom-line"></div>
		<div class="service-bottom-right" @click="toService">
			<img class="service-icon" :src="onlineIcon" alt="" />
			<div class="service-info">
				<div class="service-title">在线客服</div>
				<div class="service-tip">厂家在线服务</div>
			</div>
		</div>
	</div>
</template>

<script>
import Byd from '@/utils/Byd.js'
import getSearchParams from '@/utils/getSearchParams'
import { track } from '@/utils/tracking.js'
import serviceIcon from '@/assets/image/service_icon.png'
import onlineIcon from '@/assets/image/online_icon.png'
const { chatFromEnter, needReadProductInfo } = getSearchParams()

export default {
	name: 'service-page-bottom',
	props: {
		left: {
			type: String,
			default: '',
		},
		right: {
			type: String,
			default: '',
		},
		butlerFeature: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			chatProductDetailStr: '',
			serviceIcon,
			onlineIcon
		}
	},
	methods: {
		toService() {
			// d: 在线客服：统计用户点击在线客服入口的数量
			track({
				param: {
					eventCode: 'online_service_click',
					pageCode:'self_service_page'
				},
			})

			Byd.navigateToNative(
				{
					name: 'toOnlineService',
					extend: {
						chatFromEnter: chatFromEnter,
						chatProductDetailStr: this.chatProductDetailStr,
						needCheckServicePage: false
					}
				},
				{
					success: res => {
						if (res.code === 200) {
							console.log('返回参数：', res.data)
						}
					},
					fail: err => {
						console.error('调用失败:', err.error)
					},
				}
			)
		},

		getOnlineServiceProductInfo() {
			Byd.getOnlineServiceProductInfo({}, {
				success: res => {
					if (res.code === 200) {
						console.log('返回参数：', res.data)
						this.chatProductDetailStr = res.data
					}
				},
				fail: err => {
					console.error('调用失败:', err.error)
				},
			})
		},

		toJinChengButler() {
			// e: 精诚服务管家：统计用户点击精诚服务管家入口的数量
			track({
				param: {
					eventCode: 'sincere_service_butler_click',
					pageCode:'self_service_page'
				},
			})

			if (this.butlerFeature) {
				Byd.navigateToNative({
					name: 'navigateToService',
					extend: this.butlerFeature
				})
				return
			}
			this.$store.commit('showMessage', {
				message: '该功能暂未开放',
				type: 'error',
			})
		}

	},
	mounted() {
		if (needReadProductInfo == 1) {
			this.getOnlineServiceProductInfo()
		}
	},
}
</script>

<style scoped lang="less">
.service-page-bottom {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	.px2rem(padding-top, 6);
	padding-bottom: max(0.16rem, env(safe-area-inset-bottom, 0px));
	display: flex;
	align-items: center;
	box-sizing: border-box;
	background-color: #fff;

	.service-bottom-left,
	.service-bottom-right {
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;

		.service-icon {
			.px2rem(width, 24);
			// .px2rem(height, 36);
			.px2rem(margin-right, 8);
		}

		.service-info {
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		.service-title {
			.px2rem(font-size, 12);
			color: #1A1D25;
			.px2rem(line-height, 20);
			// .px2rem(margin-bottom, 4);
			font-weight: 500;
		}

		.service-tip {
			color: #9BA1AF;
			.px2rem(font-size, 12);
			transform: scale(0.75) translateX(-16%);
			.px2rem(line-height, 12);
		}
	}

	.service-bottom-line {
		position: relative;
		width: 1px;
		background: none;
		.px2rem(height, 40);
	}
	.service-bottom-line::after {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 1px;
		height: 100%;
		background: #E9EAED;
		/* 高清屏缩放，强制物理1px */
		transform: scaleX(1);
	}

	/* 针对高清屏（2倍屏） */
	@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
		.line::after {
			transform: scaleX(0.5);
		}
	}

	/* 针对超高清屏（3倍屏） */
	@media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
		.line::after {
			transform: scaleX(0.333);
		}
	}
}
</style>
